import ZTypography from "@atoms/ZTypography";
import { Progress } from "antd";
import React, { memo } from "react";
import { IPipelineProgressProps } from "./interface";
import "./index.less";

const ZPipelineProgress: React.FC<IPipelineProgressProps> = ({
	opportunityInsights,
	className
}) => {
	if (!opportunityInsights?.stage_index || !opportunityInsights?.no_of_stages)
		return null;
	const percent = Math.floor(
		(opportunityInsights.stage_index * 100) /
			opportunityInsights.no_of_stages
	);
	return (
		<div className={`z-pipeline-progress ${className ?? ""}`}>
			<ZTypography.ZTitle level={1} className="mb-2">
				Pipeline Progress ({opportunityInsights.stage_index} out of{" "}
				{opportunityInsights.no_of_stages} stages)
			</ZTypography.ZTitle>
			<Progress percent={percent} />
		</div>
	);
};

export default memo(ZPipelineProgress);
